module.exports = __webpack_public_path__ + "static/media/conflnk_103.7dcf3c09.ico";